import BasePopup from "../../../../src/scripts/classes/BasePopup";

var PopupUnit = function(options) {
	// Call parent constructor
	BasePopup.call(this, $.extend(true, {
		baseClass: 'el-PopupUnit',
		dotSelector: '.popup-unit_icon-wrapper',
		popupSelector: '.popup-unit_wrapper',
		pointerSelector: '.popup-unit_pointer',
		componentName: 'PopupUnit'
	}, options));
};

// Inherit from BasePopup
PopupUnit.prototype = Object.create(BasePopup.prototype);
PopupUnit.prototype.constructor = PopupUnit;

// Override init - Apply Now functionality is now handled by Modal trigger system
PopupUnit.prototype.init = function() {
	// Call parent init first
	BasePopup.prototype.init.call(this);
	
	// Apply Now buttons use href="#apply-now" and are handled in Modal.js
};

export default PopupUnit;
